<template>
  <div class="bg">
    <!-- ml-5 pl-5 pr-5 mr-5  -->
    <CCard class="border-0 CCCard pb-5">
      <CRow class="CTabCover">
        <CCol class="tab CTabMenu col-sm-3">
          <ul
            id="accountmanagementTab"
            role="tablist"
            class="nav nav-tabs Cul shadowMenu"
            ref="ul"
          >
            <li class="nav-item CListFirst firstMenu">
              <a
                class="nav-link CMenuText active"
                id="account-tab"
                data-toggle="tab"
                href="#am"
                ref="am"
                role="tab"
                aria-controls="account"
                aria-selected="false"
                style="border-top-left-radius: 20px"
              >
                <img
                  src="@/assets/icons/menubar/human.svg"
                  class="pl-3 mr-4 menuImage"
                />
                <span class="span-text">ACCOUNT MANAGEMENT</span>
              </a>
            </li>
            <li
              class="nav-item"
              v-for="(tab, index) in tabs"
              :key="index"
              :class="index === 0 ? 'CListFirst' : 'CMenuText'"
            >
              <a
                :ref="tab.ref"
                class="nav-link CMenuText"
                :id="tab.id"
                data-toggle="tab"
                :href="tab.href"
                role="tab"
                :aria-controls="tab.control"
                aria-selected="false"
              >
                <img :src="tab.image" class="pl-3 mr-4 menuImage" />
                <span class="span-text">{{ tab.title }}</span>
              </a>
            </li>
            <!--
            <li class="nav-item CListLast">
              <a
                class="nav-link CMenuText CListLast"
                id="mycertificate-tab"
                data-toggle="tab"
                ref="mc"
                href="#mc"
                role="tab"
                aria-controls="mycertificate"
                aria-selected="false"
              >
                <img src="@/assets/icons/menubar/certificate.svg" class="pl-3 mr-4 menuImage" />
                <span class="span-text">MY CERTIFICATE</span>
              </a>
            </li>-->
          </ul>
          <!--                    <ul id="accountmanagementTab" role="tablist" class="nav nav-tabs Cul shadowMenu">-->
          <!--                        <li class="nav-item CListFirst">-->
          <!--                            <a-->
          <!--                                    class="nav-link active CMenuText CListFirst"-->
          <!--                                    id="account-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#am"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="account"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/human.svg" class="pl-3 mr-2 menuImage"/>-->
          <!--                                <span>ACCOUNT MANAGEMENT</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                        <li class="nav-item">-->
          <!--                            <a-->
          <!--                                    class="nav-link CMenuText"-->
          <!--                                    id="changepassword-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#cp"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="changepassword"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/key.svg" class="pl-3 mr-2 menuImage"/>-->
          <!--                                <span>CHANGE PASSWORD</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                        <li class="nav-item">-->
          <!--                            <a-->
          <!--                                    class="nav-link CMenuText"-->
          <!--                                    id="paymentmethods-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#pm"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="paymentmethods"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/payment.svg" class="pl-3 mr-2 menuImage"/>-->
          <!--                                <span>PAYMENT METHODS</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                        <li class="nav-item">-->
          <!--                            <a-->
          <!--                                    class="nav-link CMenuText"-->
          <!--                                    id="purchasedhistory-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#ph"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="purchasedhistory"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/purchase.svg" class="pl-3 mr-2 menuImage"/>-->
          <!--                                <span>PURCHASED HISTORY</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                        <li class="nav-item">-->
          <!--                            <a-->
          <!--                                    class="nav-link CMenuText"-->
          <!--                                    id="notifications-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#no"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="notifications"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/bell.svg" class="pl-2 mr-1 notiImage"/>-->
          <!--                                <span>NOTIFICATIONS</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                        <li class="nav-item CListLast">-->
          <!--                            <a-->
          <!--                                    class="nav-link CMenuText CListLast"-->
          <!--                                    id="mycertificate-tab"-->
          <!--                                    data-toggle="tab"-->
          <!--                                    href="#mc"-->
          <!--                                    role="tab"-->
          <!--                                    aria-controls="mycertificate"-->
          <!--                                    aria-selected="false"-->
          <!--                            >-->
          <!--                                <img src="@/assets/icons/menubar/certificate.svg" class="pl-3 mr-2 menuImage"/>-->
          <!--                                <span>MY CERTIFICATE</span>-->
          <!--                            </a>-->
          <!--                        </li>-->
          <!--                    </ul>-->
        </CCol>

        <CCol
          id="accountManagementTabContent"
          class="tab-content col-12 col-sm-9 pr-3"
        >
          <div
            class="tab-pane fade show active"
            id="am"
            role="tabpanel"
            aria-labelledby="account-tab"
          >
            <accountManagement />
          </div>
          <div
            class="tab-pane fade"
            id="cp"
            role="tabpanel"
            aria-labelledby="changepassword-tab"
          >
            <changePassword />
          </div>
          <div
            class="tab-pane fade"
            id="pm"
            role="tabpanel"
            aria-labelledby="paymentmethods-tab"
          >
            <paymentMethods />
          </div>
          <div
            class="tab-pane fade"
            id="ph"
            role="tabpanel"
            aria-labelledby="purchasedhistory-tab"
          >
            <purchasedHistory />
          </div>
          <div
            class="tab-pane fade"
            id="no"
            role="tabpanel"
            aria-labelledby="notifications-tab"
          >
            <notifications />
          </div>
          <div
            class="tab-pane fade"
            id="mc"
            role="tabpanel"
            aria-labelledby="mycertificate-tab"
          >
            <myCertificate />
          </div>
          <div
            class="tab-pane fade"
            id="lp"
            role="tabpanel"
            aria-labelledby="learningprofile-tab"
          >
            <learningProfile />
          </div>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>
<script>
import accountManagement from "../components/accountmanagement/AccountManagement";
import changePassword from "../components/accountmanagement/ChangePassword";
import paymentMethods from "../components/accountmanagement/PaymentMethods";
import purchasedHistory from "../components/accountmanagement/PurchasedHistory";
import notifications from "../components/accountmanagement/Notifications";
import myCertificate from "../components/accountmanagement/MyCertificate";
import learningProfile from "../components/screen/LearningProfile";
export default {
  name: "MyProfile",
  data() {
    return {
      tabs: [
        /*
        {
          title: "LEARNING PROFILE",
          image: require("@/assets/icons/menubar/purchase.svg"),
          id: "account-tab",
          href: "#lp",
          control: "account",
          ref: "lp",
        },
        */
        {
          title: "CHANGE PASSWORD",
          image: require("@/assets/icons/menubar/key.svg"),
          id: "changepassword-tab",
          href: "#cp",
          control: "changepassword",
          ref: "cp",
        },
        /*
        {
          title: "PAYMENT METHOD",
          image: require("@/assets/icons/menubar/payment.svg"),
          id: "paymentmethods-tab",
          href: "#pm",
          control: "paymentmethods",
          ref: "pm",
        },
        {
          title: "PURCHASED HISTORY",
          image: require("@/assets/icons/menubar/purchase.svg"),
          id: "purchasedhistory-tab",
          href: "#ph",
          control: "purchasedhistory",
          ref: "ph",
        },
        */
        {
          title: "NOTIFICATIONS",
          image: require("@/assets/icons/menubar/bell.svg"),
          id: "notifications-tab",
          href: "#no",
          control: "notifications",
          ref: "no",
        },
        // {
        //     title: "MY CERTIFICATE",
        //     image: require('@/assets/icons/menubar/certificate.svg'),
        //     id: "mycertificate-tab",
        //     href: "#mc",
        //     control: 'mycertificate',
        //     ref: 'mc'
        // },
      ],
      activeTab: 1,
    };
  },
  components: {
    accountManagement,
    changePassword,
    paymentMethods,
    purchasedHistory,
    notifications,
    myCertificate,
    learningProfile,
  },
  watch: {
    "$route.params": function (val) {
      this.switchTab(val.signal);
    },
  },
  created() {
    //this.switchTab($route.params.signal);
  },
  mounted: function () {
    this.switchTab(this.$route.params.signal);
  },
  methods: {
    switchTab: function (val) {
      switch (val) {
        case "lp":
          this.$refs.lp[0].click();
          return;
        case "pm":
          this.$refs.pm[0].click();
          return;
        case "cp":
          this.$refs.cp[0].click();
          return;
        case "ph":
          this.$refs.ph[0].click();
          return;
        case "no":
          this.$refs.no[0].click();
          return;
        case "mc":
          this.$refs.mc.click();
          return;
        case "am":
          this.$refs.am.click();
          return;
        default:
          this.$refs.am.click();
          return;
      }
    },
  },
};
</script>

<style scoped>
.firstMenu:hover {
  border-top-left-radius: 20px;
}
.shadowMenu {
  border-bottom-left-radius: 0.75rem;
  -webkit-box-shadow: 0px 0px 30px 1px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 30px 1px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 30px 1px rgba(204, 204, 204, 1);
  border-color: #cccccc;
}
a {
  text-decoration: none;
  color: black;
}
.span-text {
  font-size: 100%;
  /* margin-left: 10px; */
  /* font-size: 0.rem; */
}

.CCCard {
  border-top-left-radius: 30px;
  background-color: transparent;
  margin: 0 3.5rem;
}

.CTabMenu {
  padding-left: 0;
  padding-right: 0px;
  z-index: 0;
  background-color: transparent;
}

.Cul {
  background-color: #cccccc;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

.bg {
  background-image: url("../assets/icons/ManagementBG.png");
  background-size: cover;
  width: 100%;
  min-height: 1080px;
  padding-top: 5rem;
}

.nav-item {
  width: 100%;
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: black;
  border: 0;
  background-color: #fff;
  border-top-right-radius: 0;
}

.nav-tabs :hover {
  border: 0;
  background: white;
  opacity: 0.75;
  /* background-color: lightgray; */
}

.nav-link {
  border-top-left-radius: 0;
}

.CMenuText {
  font-family: Roboto;
  font-weight: bold;
}

.CListFirst {
  /*border-top-left-radius: 20px;*/
}

.CListLast {
  border-bottom-left-radius: 20px;
}

.menuImage {
  display: inline-block;
  width: 2rem;
  height: 2rem;
}

.notiImage {
  width: 2.4rem;
  height: 2.4rem;
}

.CTabCover {
  border-radius: 20px;
}

a span {
  display: inline-block;
}


@media screen and (max-width: 415px) {
  .tab-content {
    margin-top: 5%;
  }
}

/* ipad layout */

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .span-text {
    font-size: 70%;
  }
}

/* end of ipad layout */

@media only screen and (max-width: 1200px) {
  .menuImage {
    display: none;
  }
  .CCCard {
    /* ml-5 pl-5 pr-5 mr-5  */
    margin: 0 1.5rem;
  }
}

@media only screen and (max-width: 500px) {
  .CTabCover {
    margin-top: 0em;
  }
}
</style>
